const cartURL = window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart` : '/cart';

// Send helper
const send = {
    get(url, options = {}) {
        return fetch(url, {
            method: 'GET',
            mode: 'cors',
            headers: {'Content-Type': 'application/json'},
            ...options
        });
    },

    post(url, body, options = {}) {
        return fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(body),
            ...options
        });
    }
}

// Get all cart items
const getCart = async () => {
    const response = await send.get(cartURL + '.js');

    return await response.json();
}

const updateCartAttribute = (body) => {
    return send.post(`${cartURL}/update.js`, body).then((response) => response.json());
}

const supplements = () => {
    const supplement = document.querySelector(".supplement");

    if (!supplement) return false;

    const selects = supplement.querySelectorAll('.supplement-select');

    selects.forEach((select, index) => {
        select.addEventListener('change', (event) => {

            const data = {
                'id': select.options[select.options.selectedIndex].value
            }

            if (!select.value || select.value === 'None') return;

            fetch(`${cartURL}/add.js`, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(data)})
                .then(() => location.reload());
        });
    });
}

// Cart Init
const cartInit = async () => {
    const cartForm = document.getElementById('CartPageForm');

    if (!cartForm) return false;

    const textareaElements = cartForm.querySelectorAll('textarea[name^="attributes["]');

    const onChangeTextareaHandle = async (event) => {

        const value = event.target.value.trim();

        const key = event.target.getAttribute('name').split('[')[1].slice(0, -1);

        const body = {
            attributes: {
                [key]: value,
            }
        }

        await updateCartAttribute(body);
    }

    for (const textareaElement of textareaElements) {
        textareaElement.addEventListener('change', onChangeTextareaHandle);
    }
}

const pageInit = () => {
    supplements();
    cartInit();
}

// Init function cartInit when DOM loaded
document.addEventListener('DOMContentLoaded', pageInit);
